import { render, staticRenderFns } from "./Skills.vue?vue&type=template&id=c3c2bb98&scoped=true&"
var script = {}
import style0 from "./Skills.vue?vue&type=style&index=0&id=c3c2bb98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c2bb98",
  null
  
)

export default component.exports